import AppointmentStatusCard from './AppointmentStatusCard'

export default AppointmentStatusCard
